var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M12.608 9.362v2.925a2 2 0 0 1-2 2H3.98a2 2 0 0 1-2-2V5.66a2 2 0 0 1 2-2H6.64"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.888 1.368c0 .474.384.858.858.858h4.463a.5.5 0 0 1 .5.496l.003.378.032 4.125a.858.858 0 0 0 1.717 0l-.039-5.857a.86.86 0 0 0-.858-.858H8.746a.86.86 0 0 0-.858.858",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m7.295 8.597 6.392-6.392"
})));
export default SvgIconExternalLink;